exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/* @import '../../css/Selector.css'; */\n/* Sync for Science Discovery CategoryRollup Stylesheet */\n/* v.01.28 Updated 11/14/2019 */\n.category-rollup-svg-container {\n   position: relative;\n   left: 0;\n   top: 0;\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   height: 32px;\n   max-height: 32px;\n   width: 100%; \n   padding: 12px 0 0 0;\n   margin: -50px 0 0 0;\n   overflow: hidden; \n}\n.category-rollup-svg { \n   position: relative;\n   height: inherit;\n   overflow: visible;\n   margin: 0;\n}", ""]);

// exports
